import React from 'react';
import { createClient } from '@/app/utils/supabase/client';
import ToastMessage from '@/components/ui/ToastMessage';
import { AttributesInput } from '@/components/ui/AttributesInput';
import { FormData } from '@/components/data/dataType';
import { formInfo } from './formInfo';

const EditForm: React.FC<{
    formData: FormData;
    locale: string;
    onClose: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
    onSuccess: (updatedForm: unknown) => void;
}> = ({ formData, locale, onClose, onSuccess }) => {
    const supabase = createClient();

    const handleSubmit = async values => {
        const { error, data } = await supabase
            .from('forms')
            .update({
                ...values,
                modified_at: new Date(),
            })
            .eq('id', formData.id)
            .select();

        if (error) {
            ToastMessage({
                type: 'error',
                message: `Erreur : ${error.message}`,
            });
        } else {
            ToastMessage({
                type: 'success',
                message: 'Formulaire mis à jour avec succès',
            });
            onSuccess(data[0]);
        }
    };

    return (
        <AttributesInput
            attributes={formData}
            fields={formInfo}
            locale={locale}
            onCancel={event => onClose(event)}
            onSubmitChanges={handleSubmit}
            title="Paramètres du formulaire"
        />
    );
};

export default EditForm;
